import { actionTypes } from '../actionTypes';
import { ISubscriptionReportState } from '../../model/subscriptionReports';
import {
  filterAllData

} from './enclouserPOFilters'

export const enclosurePOReducer = (state: ISubscriptionReportState[] = [], action: any) => {
  switch (action.type) {
    case actionTypes.LOAD_ENCLOSURE_PO_ALL_SUCCESS:
      return {
        // ...state,
        InProgress: filterAllData(action.payload, 'inProgress'),
        Delivered: filterAllData(action.payload, 'delivered')

      }
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/store/enclosurePO/reducer.ts